<script setup lang="ts"></script>

<template>
  <div
    aria-hidden="true"
    class="flex flex-col gap-6"
  >
    <div class="card h-56 animate-pulse bg-sunken motion-reduce:animate-none sm:h-64" />
    <div class="grid grid-cols-2 gap-3 sm:grid-cols-4">
      <div
        v-for="n in 4"
        :key="n"
        class="card h-24 animate-pulse bg-sunken motion-reduce:animate-none"
      />
    </div>
    <div class="flex flex-col gap-3">
      <div
        v-for="n in 4"
        :key="n"
        class="card h-20 animate-pulse bg-sunken motion-reduce:animate-none"
      />
    </div>
  </div>
  <p class="sr-only">
    Loading the report.
  </p>
</template>
